import React from "react";
import { useState, useEffect } from "react";
import BoostrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { useSelector } from "react-redux";
import { HttpJsonHeader } from "../../../features/Environments";
import { Button, Badge, OverlayTrigger, Tooltip } from "react-bootstrap";
import axios from "axios";
import { AiFillEdit, AiOutlineDelete, AiOutlinePlus } from "react-icons/ai";

import BrchPopup from "./BrchPopup";
import ModalDialog from "../../components/ModalDialog";
import { SerachBox } from "../../components/SerachBox";
import { PageOptions } from "../../components/PageParams";
import { BranchService } from "../../../model/branch";
import ConfirmDialogB from "../../components/ConfirmDialogB";

export default function Branch() {
  const userDetail = useSelector((state) => state.user.detail);
  const [data, setData] = useState([]);
  const [fields, setFields] = useState(null);
  const [popupVisible, setPopupVisible] = useState(false);
  const [updateFlag, setUpdateFlag] = useState(true);
  const [confirmBox, setConfirmBox] = useState({
    show: false,
    title: null,
    action: () => {},
  });

  const props = {
    formName: "สาขา",
    show: popupVisible,
    fields: fields,
    hidePopup: () => {
      setPopupVisible(false);
    },
    setUpdate: setUpdateFlag,
    user: userDetail,
  };

  useEffect(() => {
    if (updateFlag) {
      getData();
      setUpdateFlag(false);
    }
  }, [updateFlag]);

  const getData = async () => {
    let data = await BranchService.GetList({});
    data && setData(data);
  };

  const popupNew = () => {
    setFields(null);
    setPopupVisible(true);
  };

  const popupData = (row) => {
    setFields(row);
    setPopupVisible(true);
  };

  const popupDelete = (row) => {
    setConfirmBox({
      show: true,
      action: (isOk) => {
        if (isOk) deleteRow(row);
      },
    });
  };

  const deleteRow = async (data) => {
    await BranchService.Delete({
      BrchId: data.brchid,
      UpdateBy: userDetail.userid,
    });
    setUpdateFlag(true);
  };

  const formatEditBox = (x, row) => {
    return (
      <div>
        <OverlayTrigger
          placement="top"
          overlay={(props) => <Tooltip {...props}>แก้ไข</Tooltip>}
        >
          <Button
            variant="info"
            className="info-button"
            onClick={() => popupData(row)}
          >
            <AiFillEdit />
          </Button>
        </OverlayTrigger>

        <OverlayTrigger
          placement="top"
          overlay={(props) => <Tooltip {...props}>ลบ</Tooltip>}
        >
          <Button
            variant="danger"
            className="info-button"
            onClick={() => {
              popupDelete(row);
            }}
          >
            <AiOutlineDelete />
          </Button>
        </OverlayTrigger>
      </div>
    );
  };

  const commonNonBorder = () => {
    return { border: "none", color: "var(--table-text-color)" };
  };
  const columns = [
    {
      dataField: "brchcode",
      text: "รหัส",
      sort: true,
      style: commonNonBorder,
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "brchname",
      text: "ชื่อสาขา",
      sort: true,
      style: commonNonBorder,
    },
    {
      dataField: "compshort",
      text: "บริษัท",
      sort: true,
      style: commonNonBorder,
    },
    {
      dataField: null,
      text: "",
      headerStyle: () => {
        return { width: "105px" };
      },
      formatter: formatEditBox,
      align: "center",
    },
  ];

  return (
    <>
      <div style={{ padding: "2px" }}>
        <div className="table-caption-box">
          <OverlayTrigger
            placement="top"
            overlay={(props) => <Tooltip {...props}>เพิ่มข้อมูลใหม่</Tooltip>}
          >
            <Button variant="primary" onClick={popupNew}>
              <AiOutlinePlus /> เพิ่มข้อมูลใหม่
            </Button>
          </OverlayTrigger>
          <div className="table-caption-box-right-flex">{props.formName}</div>
          <SerachBox
            onButtonClick={() => {
              setUpdateFlag(true);
            }}
          />
        </div>

        <BoostrapTable
          bootstrap4
          keyField="brchid"
          rowClasses={"table-next-rows-style"}
          data={data}
          columns={columns}
          striped
          hover
          condensed
          // tabIndexCell
          headerWrapperClasses="headerWrapper"
          wrapperClasses="bs-table-wrapper"
          bordered={true}
          pagination={paginationFactory(PageOptions)}
          // rowStyle = {rowStyle2}
          // rowEvents= {rowEvents}
        />
      </div>
      <BrchPopup props={props} />

      {/* <ModalDialog
        confirm={confirmBox}
        setConfirm={setConfirmBox}
        action={deleteRow}
      /> */}
      <ConfirmDialogB {...{ winState: [confirmBox, setConfirmBox] }} />
    </>
  );
}
